/**
 * Input Schema of RequestSsw
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {RequestSsw} from '@/model/resource/RequestSsw'

/* TODO: review generated schema */
export class InputRequestSswSchema extends Schema {
  readonly name = 'InputRequestSsw'

  readonly fieldSet: FieldSet<RequestSsw> = {
    notaFiscal: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 80,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    json: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
